<template>
    <BasicHeader
        pretitle="aqfer Universal Tag"
        title="Custom Initiators"
        buttonText="Add Initiator"
        :buttonRoles="btnRoles"
        @btnClick="showModal({ component: 'AddClientInitiator'})"
    />
    <div class="container-fluid">
        <div class="card">
            <Datatable
                tableId="clientInitiatorsList"
                :columns="columns"
                :data="$store.state.aut.cidInitiators"
                @deleteRows="showDeleteClientInitiators"
                :deletable="deletable"
                :compact="true"
                :selectCheckboxes="true"
                uniqueField="name"
                :detailColumn="{baseUrl:'client-initiators/', name: 'Client Initiator', identifier: 'name', identifierName: 'name'}"
            />
        </div>
    </div>
</template>
<script>
import BasicHeader from '../../components/BasicHeader.vue';
import Datatable from '../../components/Datatable.vue';
import { mapActions } from 'vuex';
export default{
    name:"ClientInitiators",
    components: { BasicHeader, Datatable },
    data(){
        return {
            columns: [
                { data: 'name' },
                { data: 'value' },
                { data: 'tag_type' },
                { data: 'url' },
                { data: 'description'}
            ],
            //Note: client admins manage their own initiators, so rank 3 is allowed
            //here even though the global pages stay aqfer-only
            btnRoles: [1, 1.5, 3],
            allowedRoles: [1, 1.5, 3]
        }
    },
    beforeMount(){
        this.$store.dispatch("aut/fetchCidInitiators");
    },
    methods: {
        showDeleteClientInitiators(rows){
            this.showModal({ component: "DeleteClientInitiators", data: rows });
        },
        ...mapActions({
            showModal :"showModal",
        })
    },
    computed: {
        deletable(){
            return this.allowedRoles.includes(this.$store.getters.userRoles.userRoleRank)
        }
    }
}
</script>
<style>
</style>
